export default "__VITE_ASSET__26631aac__"